import { useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import QuickLink from "../utils/QuickLink";
import MunCommittees from "../utils/MunCommittees";
import MunTestimonial from "../utils/MunTestimonial";

const NcsMun = () => {
  const [showTestimonialFull, setShowTestimonialFull] = useState(false);

  const munButtons = [
    { title: "Register Now", href: "#register-now" },
    { title: "Explore Committees 2026", href: "#committees" },
    { title: "Schedule", href: "#schedule" },
    { title: "Download Brochure", href: "#brochure" },
    { title: "Contact", href: "#contact" },
    { title: "Previous MUNs", href: "#previous-muns" },
    { title: "Social Media Pages", href: "#social-media" },
  ];

  const skillsDeveloped = [
    { title: "Public Speaking" },
    { title: "Research" },
    { title: "Negotiation" },
    { title: "Diplomacy" },
    { title: "Leadership" },
    { title: "Critical Thinking" },
    { title: "Collaboration" },
  ];

  const committees = [
    {
      CommitteesName: "UNITED NATIONS HUMAN RIGHTS COUNCIL",
      Chair: "[Name of Student]",
      Deputy: "[Name of Student]",
      message:
        "The United Nations Human Rights Council serves as a platform where delegates uphold fundamental freedoms, address violations, and work collectively to protect the rights and dignity of people across the world. Acting as the conscience of the international community, it strives to build a just and equitable world.",
    },
    {
      CommitteesName: "UNITED NATIONS SECURITY COUNCIL",
      Chair: "[Name of Student]",
      Deputy: "[Name of Student]",
      message:
        "The United Nations Security Council is not merely a chamber of debate; it is the arena where global crises are confronted, alliances are forged, international tensions are addressed, and the fate of world peace hangs in the balance. The United Nations Security Council meets amid growing strategic competition between the United States and China in the Indo-Pacific region. Escalating tensions in the Taiwan Strait, disputes in the South China Sea, and the strengthening of military alliances have raised concerns over regional stability and international peace.",
    },
    {
      CommitteesName: "LOK SABHA",
      Chair: "[Name of Student]",
      Deputy: "[Name of Student]",
      message:
        "The Lok Sabha embodies the heart of India's democratic process. Members debate national issues, draft policies, and engage in spirited parliamentary discourse, reflecting the complexities and dynamism of the world's largest democracy.",
    },
    {
      CommitteesName: "GUJARAT LEGISLATIVE ASSEMBLY",
      Chair: "[Name of Student]",
      Deputy: "[Name of Student]",
      message:
        "The Gujarat Legislative Assembly provides a platform to address the opportunities and challenges shaping one of India's most progressive states. Delegates examine and discuss regional governance, public welfare, and state policy while navigating the realities of contemporary politics.",
    },
    {
      CommitteesName: "INTERNATIONAL PRESS",
      Chair: "[Name of Student]",
      Deputy: "[Name of Student]",
      message:
        "Armed not with votes but with the power of the pen, the International Press stands as the conference's watchful eye. Every statement, every alliance, and every controversy finds its way into the headlines they create.",
    },
  ];

  const testimonial = {
    title: "NCS MUN",
    message:
      "“Human rights at the centre of global responsibility.” “Deliberation for peace, action for stability.” “Where every voice seeks to shape a nation of billions.” “Driving progress through local leadership.” “The delegates make history. The press decides how it is remembered.”",
    agenda:
      "NCS MUN is more than a simulation. It is a learning experience that nurtures awareness, empathy, and responsible leadership.",
  };

  const introText = [
    "NCS MUN provides students with an opportunity to engage with the issues shaping our world while developing the confidence to articulate their perspectives. Through committee sessions, negotiations, and collaborative problem-solving, delegates learn to analyse complex challenges, and defend their positions with evidence while working towards practical solutions.",
    "Following the strong foundation laid by our intra-school conferences, NCS MUN 2026-27 now welcomes participation from schools beyond our campus, creating a broader forum for dialogue and exchange. The conference encourages girl students from Grades 9-12 to examine matters of international significance alongside concerns that affect our nation and local communities.",
    "More than a simulation, NCS MUN is a learning experience that nurtures awareness, empathy, and responsible leadership. We aspire to empower young women who are informed, empathetic, thoughtful in their actions, and committed to making a meaningful difference in the world around them.",
  ];

  return (
    <>
      <Header />
      <div className="breadcrumb">
        <h1>Nirmala Convent School Model United Nations</h1>
        <h6>
          Developing future leaders through debate, negotiation, and global
          awareness.
        </h6>
        <ul>
          <li>
            <a href="/">Home</a> &nbsp; &nbsp;|
          </li>
          <li>NCS MUN &nbsp; &nbsp;|</li>
          <li>Nirmala Convent School Model United Nations</li>
        </ul>
      </div>
      <div className="innerPage mun_ncs-block">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="mun-intro-head">
                <h3>About NCS MUN</h3>
              </div>
              <div className="mun-intro-copy">
                {introText.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}
              </div>
            </div>
            <div className="col-md-12">
              <div className="mun-principal-invitation" id="principal-invitation">
                <div className="mun-principal-badge">Principal Invitation</div>
                <h3>Invitation to NCS MUN</h3>
                <p>Respected Principal,</p>
                <p>
                  Greetings from Nirmala Convent School, Rajkot. We are pleased
                  to invite your esteemed institution to participate in NCS MUN
                  2026-27, our first inter-school Model United Nations conference.
                </p>
                <p>
                  We believe this conference will provide your students with a
                  meaningful platform to enhance their confidence, public
                  speaking, teamwork, and leadership skills through thoughtful
                  discussion and healthy debate on relevant global as well as
                  local issues. It will also encourage them to broaden their
                  perspective, and learn the value of diplomacy. We sincerely
                  hope you will encourage your students to take part in this
                  enriching experience.
                </p>
                <p>
                  We look forward to your gracious support and participation.
                </p>
                <p>
                  Yours sincerely,
                  <br />
                  Sr. Betty Mathew
                  <br />
                  Principal
                  <br />
                  Nirmala Convent School, Rajkot
                </p>
              </div>
            </div>


            <div className="col-md-12">
              <QuickLink items={skillsDeveloped} />
            </div>
            <div className="col-md-12">
              <div className="mun-actions">
                {munButtons.map((item, index) => (
                  <a key={item.title || index} className="mun-btn" href={item.href}>
                    {item.title}
                  </a>
                ))}
              </div>
            </div>
            <div className="col-md-12" id="committees">
              <div className="mun-section-head">
                <h3>Explore Committees 2026</h3>
              </div>
              <MunCommittees committees={committees} />
            </div>
            
           
            <div className="col-md-12">
              <div className="mun_info_action_link">
                <a className="mun-info-card is-accent" href="#register-now">
                  <h3>Register Now</h3>
                </a>
                <a className="mun-info-card" href="#schedule">
                  <h3>Schedule</h3>
                </a>
                <a className="mun-info-card" href="#brochure">
                  <h3>Download Brochure</h3>
                </a>
                <a className="mun-info-card" href="#contact">
                  <h3>Contact</h3>
                </a>
                <a className="mun-info-card" href="#previous-muns">
                  <h3>Previous MUNs</h3>
                </a>
                <a className="mun-info-card" href="#social-media">
                  <h3>Social Media Pages</h3>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <Footer />
    </>
  );
};

export default NcsMun;
